// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t6-2";
export var chatLink = "_t6-0";
export var chatText = "_t6-1";